import request from "../utils/fetch";

export function clientList(data) {
  return request({
    url: "/order/equipment/user/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 客户订单信息
export function clientOrder(data) {
  return request({
    url: "/order/user/statistics/get/all/sums",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 统计
export function stat(data) {
  return request({
    url: "/user/sysmanager/countUserCardNum",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 统计新
export function newStat(data) {
  return request({
    url: "/user/sysmanager/userNum/count",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 导出
export function exportClient(data) {
  return request({
    url: "/user/sysmanager/download/info",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 用户设备列表
export function userEquipment(data) {
  return request({
    url: "/equipment/customer/equipment/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 客户列表-新
export function clientListNew(data) {
  return request({
    url: "/user/sysmanager/pc/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
